import React from "react";
import './HomeSliderContent1.css'
import arrow from './resources/arrow.png'
import kshitij from './resources/kshitij.png'

function HomeSliderContent1({ onClickContact }) {
  const startYear = 2022;
  const currentYear = new Date().getFullYear();
  const experienceYears = currentYear - startYear;

  return (
    <div className="slider-row">
      <div className="slider-column">
        <div className="quote">Building efficient, reliable software solutions for embedded systems.</div>
        <div className="text">I have been coding and developing software solutions as a software engineer for over {experienceYears} years</div>
        <button className="slider-button slider-button-hover" onClick={onClickContact}>Contact Me <img src={arrow} alt="Right arrow" /></button>
      </div>
      <div className="slider-column">
        <div className="image-container">
          <div className="image-wrapper">
            <img src={kshitij} alt="Kshitij" className="responsive-image" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSliderContent1;
